import React from 'react';
import { useCurrentEditor } from '@tiptap/react';
import { FONT_SIZE } from './data';
import ToolbarDropdown from '@/components/TiptapEditor/Toolbar/Dropdowns/ToolbarDropdown';

const fields = FONT_SIZE.map((size) => ({
	label: size,
	value: size,
	type: 'size',
	default: '14px',
}));

const ToolbarFontSizeSelect = () => {
	const { editor } = useCurrentEditor();

	const activeFont =
		FONT_SIZE.find((font) => editor?.isActive('textStyle', { fontSize: font })) ?? '14px';

	return (
		<ToolbarDropdown
			title='Size'
			showSelection={true}
			defaultValue={activeFont}
			fields={fields}
			onChange={(e) => {
				const value = e.target.value;
				editor.chain().focus().setFontSize(value).run();
			}}
			sx={{
				width: '110px',
			}}
		/>
	);
};

export default ToolbarFontSizeSelect;
